import { render, staticRenderFns } from "./BillingManage.vue?vue&type=template&id=a97e8046&"
import script from "./BillingManage.vue?vue&type=script&lang=js&"
export * from "./BillingManage.vue?vue&type=script&lang=js&"
import style0 from "./BillingManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports